import spacing, { ISpacing } from './spacing';

export type { ISpacing };
export default spacing;
